<template>
  <img :src="finalSrc" :alt="alt" v-bind="$attrs" />
</template>

<script>
export default {
  name: 'BaseImage',
  props: {
    src: {
      type: String,
      required: true,
    },
    alt: {
      type: String,
      default: '',
    },
  
  },
  computed: {
    finalSrc() {
      // 如果src是以/static/开头，则拼接baseUrl和src
      if (this.src.startsWith('/static/')) {
        return `${process.env.BASE_URL}${this.src}`;
      }
      // 否则，返回原始src
      return this.src;
    },
  },
};
</script>